<div class="header-title-holder">
  <i mat-card-avatar class="workheld-icons" [innerHtml]="whIconEnum"></i>
  <h2 class="html-overflow" matTooltip="{{ extId() }} - {{ name() }}">
    <b>{{ extId() }}</b> - {{ name() }}
  </h2>
</div>
